import React from 'react';
import ImageCarousel from './ImageCarousel';
import HomeFeatures from './HomeFeatures';
import BuilderDescription from './BuilderDescription';

const BuilderDetailsCard = ({
    builder,
    isLast = false
}) => {
    const container = isLast ? 'mb-0' : 'mb-10';
    return (
        <div className={`flex flex-col lg:flex-row gap-8 ${container}`}>
            {/* Left Column - Image Carousel */}
            <div className="lg:w-1/2 relative">
                <ImageCarousel
                    images={builder.homeImages}
                    logo={builder.logo}
                    name={builder.name}
                    homeName={builder.homeName}
                />

                {/* Home Details */}
                <div className="mt-6">
                    <HomeFeatures
                        beds={builder.beds}
                        baths={builder.baths}
                        cars={builder.cars}
                        livingRooms={builder.livingRooms}
                    />
                </div>
            </div>

            {/* Right Column - Text Content */}
            <div className="lg:w-1/2">
                <BuilderDescription
                    description={builder.description}
                    homeName={builder.homeName}
                    homeDescription={builder.homeDescription}
                    buttonText={builder.buttonText}
                    buttonLink={builder.buttonLink}
                    virtualTourButton={builder.virtualTourButton}
                    locationText={builder.locationText}
                    locationLink={builder.locationLink}
                />
            </div>
        </div>
    );
};

export default BuilderDetailsCard;